module.exports = [
	{
		"title": "JS Components",
		"list": [
			{
				"path": "/toast",
				"name": "Toast",
				"icon": "toast"
			},
			{
				"path": "/indicator",
				"name": "Indicator",
				"icon": "indicator"
			},
			{
				"path": "/pull-down",
				"name": "Pull down",
				"icon": "pull-down"
			},
			{
				"path": "/pull-up",
				"name": "Pull up",
				"icon": "pull-up"
			},
			{
				"path": "/infinite-scroll",
				"name": "Infinite scroll",
				"icon": "infinite-scroll"
			},
			{
				"path": "/message-box",
				"name": "Message box",
				"icon": "message-box"
			},
			{
				"path": "/action-sheet",
				"name": "Action sheet",
				"icon": "action-sheet"
			},
			{
				"path": "/popup",
				"name": "Popup",
				"icon": "popup"
			},
			{
				"path": "/swipe",
				"name": "Swipe",
				"icon": "swipe"
			},
			{
				"path": "/lazyload",
				"name": "Lazy load",
				"icon": "lazyload"
			},
			{
				"path": "/range",
				"name": "Range",
				"icon": "range"
			},
			{
				"path": "/progress",
				"name": "Progress",
				"icon": "progress"
			},
			{
				"path": "/picker",
				"name": "Picker",
				"icon": "picker"
			},
			{
				"path": "/datetime-picker",
				"name": "Datetime Picker",
				"icon": "time"
			},
			{
				"path": "/select",
				"name": "Select",
				"icon": "picker"
			},
			{
				"path": "/textarea",
				"name": "Textarea",
				"icon": "field"
			},
			{
				"path": "/text-select",
				"name": "TextSelect",
				"icon": "picker"
			},
			{
				"path": "/picker-select",
				"name": "PickerSelect",
				"icon": "picker"
			},
			{
				"path": "/datetime-selector",
				"name": "DatetimeSelector",
				"icon": "time"
			},
			{
				"path": "/infinite-calendar",
				"name": "infinite calender",
				"icon": "infinite-scroll"
			},
			{
				"path": "/tree-selector",
				"name": "TreeSelector",
				"icon": "picker"
			},
			{
				"path": "/index-list",
				"name": "Index List",
				"icon": "alphabet"
			},
			{
				"path": "/file-list",
				"name": "File List",
				"icon": "alphabet"
			},
			{
				"path": "/palette-button",
				"name": "Palette Button",
				"icon": "alphabet"
			}
		]
	},
	{
		"title": "CSS Components",
		"list": [
			{
				"path": "/header",
				"name": "Header",
				"icon": "header"
			},
			{
				"path": "/tabbar",
				"name": "Tabbar",
				"icon": "tabbar"
			},
			{
				"path": "/navbar",
				"name": "Navbar",
				"icon": "navbar"
			},
			{
				"path": "/side-navbar",
				"name": "SideNavbar",
				"icon": "navbar"
			},
			{
				"path": "/button",
				"name": "Button",
				"icon": "button"
			},
			{
				"path": "/button-list",
				"name": "ButtonList",
				"icon": "button"
			},
			{
				"path": "/command-bar",
				"name": "CommandBar",
				"icon": "button"
			},
			{
				"path": "/cell",
				"name": "Cell",
				"icon": "cell"
			},
			{
				"path": "/cell-swipe",
				"name": "Cell Swipe",
				"icon": "cell"
			},
			{
				"path": "/spinner",
				"name": "Spinner",
				"icon": "spinner"
			},
			{
				"path": "/tab-container",
				"name": "TabContainer",
				"icon": "panel"
			},
			{
				"path": "/search",
				"name": "Search",
				"icon": "searchbar"
			},
			{
				"path": "/layout-left-right",
				"name": "LayoutLeftRight",
				"icon": "navebar"
			},
			{
				"path": "/layout-container",
				"name": "LayoutContainer",
				"icon": "navebar"
			},
			{
				"path": "/fixed-container",
				"name": "FixedContainer",
				"icon": "navebar"
			},
			{
				"path": "/layout-container-multiple",
				"name": "LayoutContainerMultiple",
				"icon": "navebar"
			},
			{
				"path": "/layout-spacing",
				"name": "LayoutSpacing",
				"icon": "navebar"
			},
			{
				"path": "/text",
				"name": "Text",
				"icon": "navebar"
			},
			{
				"path": "/hr",
				"name": "Hr",
				"icon": "navebar"
			},
			{
				"path": "/icon",
				"name": "icon",
				"icon": "navebar"
			},
			{
				"path": "/image",
				"name": "Image",
				"icon": "navebar"
			},
			{
				"path": "/fixed-button",
				"name": "FixedButton",
				"icon": "navebar"
			},
			{
				"path": "/subscript",
				"name": "Subscript",
				"icon": "navebar"
			}
		]
	},
	{
		"title": "Form Components",
		"list": [
			{
				"path": "/switch",
				"name": "Switch",
				"icon": "switch"
			},
			{
				"path": "/switcher",
				"name": "Switcher",
				"icon": "switch"
			},
			{
				"path": "/field",
				"name": "Field",
				"icon": "field"
			},
			{
				"path": "/badge",
				"name": "Badge",
				"icon": "badge"
			},
			{
				"path": "/steps",
				"name": "Steps",
				"icon": "badge"
			},
			{
				"path": "/dropdown-menus",
				"name": "DropdownMenus",
				"icon": "badge"
			},
			{
				"path": "/checkbox",
				"name": "Checkbox",
				"icon": "checklist"
			},
			{
				"path": "/radiobox",
				"name": "radiobox",
				"icon": "radio"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./example/nav.config.json
// module id = 92
// module chunks = 0